import { render, staticRenderFns } from "./PainelChamadosDisoft.vue?vue&type=template&id=095f6376"
import script from "./PainelChamadosDisoft.vue?vue&type=script&lang=js"
export * from "./PainelChamadosDisoft.vue?vue&type=script&lang=js"
import style0 from "./PainelChamadosDisoft.vue?vue&type=style&index=0&id=095f6376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports